import { useMemo } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export function DriversCards({ drivers = [], loading, ridersDataByCompany }) {
  // 1) Index del objeto externo (acepta array u objeto)
  const ridersIndex = useMemo(() => {
    if (Array.isArray(ridersDataByCompany)) {
      return ridersDataByCompany.reduce((acc, it) => {
        if (it?.id) acc[it.id] = it;
        return acc;
      }, {});
    }
    return ridersDataByCompany && typeof ridersDataByCompany === "object"
      ? ridersDataByCompany
      : {};
  }, [ridersDataByCompany]);

  // 2) Ordenar por fecha y enriquecer filas
  const rows = useMemo(() => {
    const safeDrivers = Array.isArray(drivers) ? drivers : [];
    const sorted = [...safeDrivers].sort((a, b) => {
      const aT = a?.createdAtDate?.getTime?.() ?? 0;
      const bT = b?.createdAtDate?.getTime?.() ?? 0;
      return bT - aT;
    });

    return sorted.map((d) => {
      const meta = ridersIndex?.[d.driverID] || ridersIndex?.[d.id] || null;
      return {
        id: d.id,
        driverID: d.driverID ?? "",
        createdAt: d.createdAtDate ?? null,
        name: meta?.name ?? "",
        phone: meta?.phone ?? "",
        bicciNumber: meta?.bicciNumber ?? null,
        rol: meta?.rol ?? null,
        active: typeof meta?.active === "boolean" ? meta.active : null,
      };
    });
  }, [drivers, ridersIndex]);

  // ---- Render (después de los hooks) ----
  if (loading) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!rows.length) {
    return (
      <Box sx={{ textAlign: "center", py: 6, opacity: 0.8 }}>
        <Typography variant="h6">No hay resultados</Typography>
        <Typography variant="body2">
          Intenta ajustar los filtros o revisa más tarde.
        </Typography>
      </Box>
    );
  }

  return (
    <Card
      sx={{ borderRadius: "3px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}
    >
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Conductores asignados
        </Typography>

        <TableContainer component={Paper} variant="outlined">
          <Table size="small" aria-label="tabla de conductores">
            <TableHead>
              <TableRow>
                <TableCell>Asignado</TableCell>

                <TableCell>driverID</TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>Teléfono</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={`${r.id}-${r.driverID || "nodriver"}`}>
                  <TableCell>
                    {r.createdAt ? r.createdAt.toLocaleString() : "—"}
                  </TableCell>

                  <TableCell sx={{ fontFamily: "monospace" }}>
                    {r.driverID || "—"}
                  </TableCell>
                  <TableCell>{r.name || "—"}</TableCell>
                  <TableCell>{r.phone || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
